export enum LiveStatus {
  Offline = 'offline',
  Online = 'online',
  Preparing = 'preparing',
  Recording = 'recording'
}
